<div class="container">
  <ul>
    <li>Debe cargar los siguientes documentos obligatorios para continuar.</li>
    <li>Se admiten archivos de formato PNG, JPG, PDF, rar de hasta 5MB.</li>
    <li>Tiene hasta 3 intentos por cada documento.</li>
  </ul>

  <br />
  <!-- TABLA -->
  <ng-container *ngFor="let option of documents">
    <table class="table">
      <tbody>
        <tr *ngFor="let doc of option.documents">
          <td style="width: 5rem">
            <mat-icon
              style="color: #0ebc7f"
              *ngIf="doc.scanned"
              matTooltip="Se escaneo correctamente"
              >done</mat-icon
            >
            <mat-icon
              style="color: red"
              *ngIf="doc.scanned != undefined && !doc.scanned"
              >clear</mat-icon
            >
          </td>
          <td>{{ doc.name }} (*)</td>
          <td class="buttons-table-position">
            <ng-container *ngIf="doc.spinner; else publish">
              <mat-spinner [diameter]="20"></mat-spinner>
            </ng-container>
            <ng-template #publish>
              <ng-container
                *ngIf="!doc.uploaded || !doc.scanned; else uploaded"
              >
                <button
                  mat-icon-button
                  style="color: #0ebc7f"
                  matTooltip="Modelo del documento"
                  (click)="openViewModelDocuments(doc)"
                >
                  <mat-icon>help</mat-icon>
                </button>
                <label
                  mat-icon-button
                  matTooltip="Tomar fotografía"
                  style="color: #0ebc7f"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  for="{{ doc.id }}-'camera'"
                >
                  <mat-icon class="button-camera">camera_alt</mat-icon>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  capture="enviroment"
                  id="{{ doc.id }}-'camera'"
                  (change)="loadDocument($event, doc)"
                  *ngIf="doc.canOpenCamera && cameraMovil"
                  style="display: none"
                />
                <label
                  mat-icon-button
                  matTooltip="Subir documento"
                  for="{{ doc.id }}"
                  style="color: #0ebc7f"
                >
                  <mat-icon class="button-upload"> publish</mat-icon>
                </label>
                <input
                  type="file"
                  id="{{ doc.id }}"
                  name="avatar"
                  accept="image/png, image/jpeg, application/pdf, .rar"
                  hidden
                  (change)="loadDocument($event, doc)"
                />
              </ng-container>
              <ng-template #uploaded
                ><button
                  mat-icon-button
                  matTooltip="Ver documento"
                  color="primary"
                  (click)="viewDocuments(doc)"
                >
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </ng-template>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
